import { Outlet } from 'react-router'
import Header from './Header'
import Aside from './Aside'
import { Suspense } from 'react'
import Alert from './Alert'
import CheckingData from './CheckingData'

const Layout = () => {
  return (
    <div className="main_wrapper">
      <CheckingData />
      <Aside />
      <div className="main_content">
        <Header />
        <main>
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </main>
        <Alert />
      </div>
    </div>
  )
}

export default Layout
